import { ref, watch, onUnmounted } from "vue";
import { focusTrap, focusElement } from "./component-library92.mjs";
function useDropdown(focusTrapContainer = ref(null), config = void 0) {
  const isOpened = ref(false);
  const onOpen = ref(() => {
  });
  const onClose = ref(() => {
  });
  const onToggle = ref((open2) => {
  });
  const onEsc = ref(() => {
  });
  const keyDown = ref((event) => {
  });
  const close = () => {
    isOpened.value = false;
  };
  const open = () => {
    isOpened.value = true;
  };
  const handleKeyEvent = (event) => {
    if (event.key === "Escape") {
      close();
      onEsc.value();
    }
    if (focusTrapContainer.value) {
      focusTrap(focusTrapContainer, event);
    }
    if (config == null ? void 0 : config.focusOnArrowKeys) {
      focusElement(focusTrapContainer, event);
    }
    keyDown.value(event);
  };
  watch(isOpened, (val, oldVal) => {
    if (val === oldVal)
      return;
    if (!val) {
      onClose.value();
      window.removeEventListener("keydown", handleKeyEvent);
    } else {
      onOpen.value();
      window.addEventListener("keydown", handleKeyEvent);
    }
  });
  const onClickaway = () => {
    if (!isOpened.value)
      return false;
    close();
    return true;
  };
  const toggle = (e = void 0) => {
    isOpened.value = !isOpened.value;
    onToggle.value(isOpened.value);
    if ((config == null ? void 0 : config.focusFirstOnOpen) && e && e.target && "pointerType" in e && e.pointerType === "") {
      setTimeout(() => {
        e.key = "ArrowDown";
        focusElement(focusTrapContainer, e);
      }, 1);
    }
  };
  onUnmounted(() => {
    window.removeEventListener("keydown", handleKeyEvent);
  });
  return {
    isOpened,
    onClickaway,
    keyDown,
    onEsc,
    onOpen,
    onClose,
    toggle,
    close,
    open
  };
}
export {
  useDropdown as default
};
